import { useConfirmationDialog } from '@factorialco/deprecated-design-system'
import { ArchiveQuoteDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import handleResultWithFlash from 'modules/finance/lib/handleResultWithFlash'

export const useDeleteQuoteDialog = () => {
  const { openDialog } = useConfirmationDialog()

  const [archiveQuote] = useMutation(ArchiveQuoteDocument, {
    extractorFn: (data) => data.financeMutations.archiveFinanceQuote,
    update(cache, { data }) {
      const archivedQuoteId = data?.financeMutations?.archiveFinanceQuote?.quote?.id
      if (archivedQuoteId) {
        cache.evict({
          id: cache.identify({
            id: archivedQuoteId,
            __typename: 'FinanceQuote',
          }),
        })
      }
    },
  })

  const showDeleteQuoteDialog = ({
    quoteId,
    callback,
  }: {
    quoteId: number
    callback?: () => void
  }) => {
    openDialog({
      title: i18n.t('finance.quotes.delete.title'),
      content: i18n.t('finance.quotes.delete.content'),
      illustration: 'delete',
      confirmLabel: i18n.t('finance.quotes.actions.delete'),
      onConfirm: async () => {
        const result = await archiveQuote({
          variables: {
            id: quoteId,
          },
        })

        const handled = handleResult(result, handleResultWithFlash())

        if (handled.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('finance.quotes.delete.success'),
          })
          if (callback) callback()
        }

        track(trackingEvents.accounting.quotes.delete)
      },
    })
  }

  return { showDeleteQuoteDialog }
}
